module.exports = __webpack_public_path__ + "img/zaoj.8adb7f00.png";